import { StyleSheet } from 'react-native';

export const modalStyles = StyleSheet.create({
	modalContainer: {
		width: '100%',
		height: '100%',
		padding: 0,
		margin: 0,
	},
	modalList: {
		flex: 1,
	},
});
